import { $api } from '@/shared/api/axiosInstance';
import { QueryFilter, SegmentsTimeFrame, TimeRange } from '@/features/ChartControls';
import { ResponseData } from '../../model/types';

type ResponseType = {
    params: ResponseData;
};

const getSegmentsParam = (segmentsValue: SegmentsTimeFrame) => {
    return `period=${segmentsValue}`;
};

const getTimeRangeParam = ({ startDate, endDate }: TimeRange) => {
    return `start_date=${startDate}&end_date=${endDate}`;
};

export const fetchChartData = async ({ segmentsValue, timeRange }: QueryFilter) => {
    const params = segmentsValue ? getSegmentsParam(segmentsValue) : getTimeRangeParam(timeRange!);

    const url = `/api/v1/quotes/history?${params}`;

    const { data } = await $api.get<ResponseType>(url);

    return data.params;
};
